import { VisuallyHidden } from '@vkontakte/vkui';
import { L } from '@lang';
import * as TitleComponents from './assets';
import { defaultSizes } from './consts';
import { BaseTitleImage, BaseTitleImageProps } from '../BaseTitleImage';

type Title = 'results' | 'about' | 'download';

/**
 * Компонент заголовков блоков
 */
export function TitleImage(props: Omit<BaseTitleImageProps<Title>, 'assets' | 'defaultSizes'>) {
  return (
    <>
      <BaseTitleImage {...props} assets={TitleComponents} defaultSizes={defaultSizes} />
      <VisuallyHidden Component="h2">{L.t(`crush_landing_${props.type}_visually_hidden_h2`)}</VisuallyHidden>
    </>
  );
}
